import { create } from 'zustand';
import { ApiUtils } from '@shared/utils';
import { PaymentsApi, type PostRequisitesRequest, type PostRequisitesResponse, type StoreBaseReturn } from '@shared/api';

interface UsePostRequisitesStore {
  data?: PostRequisitesResponse | null;
  loading: boolean;
  error: string | null;
  createRequisites: (request: PostRequisitesRequest, signal?: AbortSignal) => Promise<StoreBaseReturn<PostRequisitesResponse | null>>;
  clear: () => void;
}

export const usePostRequisitesStore = create<UsePostRequisitesStore>((set) => ({
  loading: false,
  data: undefined,
  error: null,

  createRequisites: async (request, signal) => {
    try {
      set({ loading: true, error: null });
      const result = await PaymentsApi.postRequisites(request, signal);
      set({ data: result || null, loading: false });
      return { loading: false, data: result || null };
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
      return { loading: false, data: null, error: ApiUtils.getApiError(error) };
    }
  },

  clear: () => set({ data: undefined, loading: false, error: null }),
}));
